"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/shipping/v1/portal_service.proto (package spwn.shipping.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalShippingServiceSetDefaultAddressResponse = exports.PortalShippingServiceSetDefaultAddressRequest = exports.PortalShippingServiceDeleteAddressResponse = exports.PortalShippingServiceDeleteAddressRequest = exports.PortalShippingServiceUpdateAddressResponse = exports.PortalShippingServiceUpdateAddressRequest = exports.PortalShippingServiceCreateAddressResponse = exports.PortalShippingServiceCreateAddressRequest = exports.PortalShippingServiceGetAddressesResponse = exports.PortalShippingServiceGetAddressesRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const portal_common_pb_1 = require("./portal_common_pb");
/**
 * @generated from message spwn.shipping.v1.PortalShippingServiceGetAddressesRequest
 */
class PortalShippingServiceGetAddressesRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalShippingServiceGetAddressesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalShippingServiceGetAddressesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalShippingServiceGetAddressesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalShippingServiceGetAddressesRequest, a, b);
    }
}
exports.PortalShippingServiceGetAddressesRequest = PortalShippingServiceGetAddressesRequest;
PortalShippingServiceGetAddressesRequest.runtime = protobuf_1.proto3;
PortalShippingServiceGetAddressesRequest.typeName = "spwn.shipping.v1.PortalShippingServiceGetAddressesRequest";
PortalShippingServiceGetAddressesRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.shipping.v1.PortalShippingServiceGetAddressesResponse
 */
class PortalShippingServiceGetAddressesResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalShippingServiceGetAddressesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalShippingServiceGetAddressesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalShippingServiceGetAddressesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalShippingServiceGetAddressesResponse, a, b);
    }
}
exports.PortalShippingServiceGetAddressesResponse = PortalShippingServiceGetAddressesResponse;
PortalShippingServiceGetAddressesResponse.runtime = protobuf_1.proto3;
PortalShippingServiceGetAddressesResponse.typeName = "spwn.shipping.v1.PortalShippingServiceGetAddressesResponse";
PortalShippingServiceGetAddressesResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "addresses", kind: "message", T: portal_common_pb_1.PortalAddresses },
]);
/**
 * @generated from message spwn.shipping.v1.PortalShippingServiceCreateAddressRequest
 */
class PortalShippingServiceCreateAddressRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string address_id = 1;
         */
        this.addressId = "";
        /**
         * @generated from field: string postal_code = 2;
         */
        this.postalCode = "";
        /**
         * @generated from field: string prefecture = 3;
         */
        this.prefecture = "";
        /**
         * @generated from field: string city = 4;
         */
        this.city = "";
        /**
         * @generated from field: string street_address = 5;
         */
        this.streetAddress = "";
        /**
         * @generated from field: string residence = 6;
         */
        this.residence = "";
        /**
         * @generated from field: string name = 7;
         */
        this.name = "";
        /**
         * @generated from field: string phone_number = 8;
         */
        this.phoneNumber = "";
        /**
         * @generated from field: bool is_default = 9;
         */
        this.isDefault = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalShippingServiceCreateAddressRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalShippingServiceCreateAddressRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalShippingServiceCreateAddressRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalShippingServiceCreateAddressRequest, a, b);
    }
}
exports.PortalShippingServiceCreateAddressRequest = PortalShippingServiceCreateAddressRequest;
PortalShippingServiceCreateAddressRequest.runtime = protobuf_1.proto3;
PortalShippingServiceCreateAddressRequest.typeName = "spwn.shipping.v1.PortalShippingServiceCreateAddressRequest";
PortalShippingServiceCreateAddressRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "address_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "postal_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "prefecture", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "street_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "residence", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "phone_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "is_default", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message spwn.shipping.v1.PortalShippingServiceCreateAddressResponse
 */
class PortalShippingServiceCreateAddressResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalShippingServiceCreateAddressResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalShippingServiceCreateAddressResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalShippingServiceCreateAddressResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalShippingServiceCreateAddressResponse, a, b);
    }
}
exports.PortalShippingServiceCreateAddressResponse = PortalShippingServiceCreateAddressResponse;
PortalShippingServiceCreateAddressResponse.runtime = protobuf_1.proto3;
PortalShippingServiceCreateAddressResponse.typeName = "spwn.shipping.v1.PortalShippingServiceCreateAddressResponse";
PortalShippingServiceCreateAddressResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "address", kind: "message", T: portal_common_pb_1.PortalAddress },
]);
/**
 * @generated from message spwn.shipping.v1.PortalShippingServiceUpdateAddressRequest
 */
class PortalShippingServiceUpdateAddressRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string address_id = 1;
         */
        this.addressId = "";
        /**
         * @generated from field: string postal_code = 2;
         */
        this.postalCode = "";
        /**
         * @generated from field: string prefecture = 3;
         */
        this.prefecture = "";
        /**
         * @generated from field: string city = 4;
         */
        this.city = "";
        /**
         * @generated from field: string street_address = 5;
         */
        this.streetAddress = "";
        /**
         * @generated from field: string residence = 6;
         */
        this.residence = "";
        /**
         * @generated from field: string name = 7;
         */
        this.name = "";
        /**
         * @generated from field: string phone_number = 8;
         */
        this.phoneNumber = "";
        /**
         * @generated from field: bool is_default = 9;
         */
        this.isDefault = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalShippingServiceUpdateAddressRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalShippingServiceUpdateAddressRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalShippingServiceUpdateAddressRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalShippingServiceUpdateAddressRequest, a, b);
    }
}
exports.PortalShippingServiceUpdateAddressRequest = PortalShippingServiceUpdateAddressRequest;
PortalShippingServiceUpdateAddressRequest.runtime = protobuf_1.proto3;
PortalShippingServiceUpdateAddressRequest.typeName = "spwn.shipping.v1.PortalShippingServiceUpdateAddressRequest";
PortalShippingServiceUpdateAddressRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "address_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "postal_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "prefecture", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "street_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "residence", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "phone_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "is_default", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message spwn.shipping.v1.PortalShippingServiceUpdateAddressResponse
 */
class PortalShippingServiceUpdateAddressResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalShippingServiceUpdateAddressResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalShippingServiceUpdateAddressResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalShippingServiceUpdateAddressResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalShippingServiceUpdateAddressResponse, a, b);
    }
}
exports.PortalShippingServiceUpdateAddressResponse = PortalShippingServiceUpdateAddressResponse;
PortalShippingServiceUpdateAddressResponse.runtime = protobuf_1.proto3;
PortalShippingServiceUpdateAddressResponse.typeName = "spwn.shipping.v1.PortalShippingServiceUpdateAddressResponse";
PortalShippingServiceUpdateAddressResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "address", kind: "message", T: portal_common_pb_1.PortalAddress },
]);
/**
 * @generated from message spwn.shipping.v1.PortalShippingServiceDeleteAddressRequest
 */
class PortalShippingServiceDeleteAddressRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string address_id = 1;
         */
        this.addressId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalShippingServiceDeleteAddressRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalShippingServiceDeleteAddressRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalShippingServiceDeleteAddressRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalShippingServiceDeleteAddressRequest, a, b);
    }
}
exports.PortalShippingServiceDeleteAddressRequest = PortalShippingServiceDeleteAddressRequest;
PortalShippingServiceDeleteAddressRequest.runtime = protobuf_1.proto3;
PortalShippingServiceDeleteAddressRequest.typeName = "spwn.shipping.v1.PortalShippingServiceDeleteAddressRequest";
PortalShippingServiceDeleteAddressRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "address_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.shipping.v1.PortalShippingServiceDeleteAddressResponse
 */
class PortalShippingServiceDeleteAddressResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string address_id = 1;
         */
        this.addressId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalShippingServiceDeleteAddressResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalShippingServiceDeleteAddressResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalShippingServiceDeleteAddressResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalShippingServiceDeleteAddressResponse, a, b);
    }
}
exports.PortalShippingServiceDeleteAddressResponse = PortalShippingServiceDeleteAddressResponse;
PortalShippingServiceDeleteAddressResponse.runtime = protobuf_1.proto3;
PortalShippingServiceDeleteAddressResponse.typeName = "spwn.shipping.v1.PortalShippingServiceDeleteAddressResponse";
PortalShippingServiceDeleteAddressResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "address_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.shipping.v1.PortalShippingServiceSetDefaultAddressRequest
 */
class PortalShippingServiceSetDefaultAddressRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string address_id = 1;
         */
        this.addressId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalShippingServiceSetDefaultAddressRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalShippingServiceSetDefaultAddressRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalShippingServiceSetDefaultAddressRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalShippingServiceSetDefaultAddressRequest, a, b);
    }
}
exports.PortalShippingServiceSetDefaultAddressRequest = PortalShippingServiceSetDefaultAddressRequest;
PortalShippingServiceSetDefaultAddressRequest.runtime = protobuf_1.proto3;
PortalShippingServiceSetDefaultAddressRequest.typeName = "spwn.shipping.v1.PortalShippingServiceSetDefaultAddressRequest";
PortalShippingServiceSetDefaultAddressRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "address_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.shipping.v1.PortalShippingServiceSetDefaultAddressResponse
 */
class PortalShippingServiceSetDefaultAddressResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string address_id = 1;
         */
        this.addressId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalShippingServiceSetDefaultAddressResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalShippingServiceSetDefaultAddressResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalShippingServiceSetDefaultAddressResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalShippingServiceSetDefaultAddressResponse, a, b);
    }
}
exports.PortalShippingServiceSetDefaultAddressResponse = PortalShippingServiceSetDefaultAddressResponse;
PortalShippingServiceSetDefaultAddressResponse.runtime = protobuf_1.proto3;
PortalShippingServiceSetDefaultAddressResponse.typeName = "spwn.shipping.v1.PortalShippingServiceSetDefaultAddressResponse";
PortalShippingServiceSetDefaultAddressResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "address_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
//# sourceMappingURL=portal_service_pb.js.map